module.exports = __webpack_public_path__ + "img/balloon1.03334549.png";